import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from './containers/Home';
import Steps from './containers/Steps';
import Result from './containers/Result';

const RouteConfigExample = () => {
    return (
        <Switch>
            <Route path="/style/:pathParam?" component={Home} />
            <Route exact path="/steps" component={Steps} />
            <Route exact path="/result" component={Result} />
        </Switch>
    );
}

export default RouteConfigExample;